import {
    ADD_IMAGE_LAYER,
    ADD_TEXT_LAYER,
    ADD_IMAGE_FROM_LIBRARY,
    SAVE_CACHE_CAPTURE,
    CHANGE_ACTIVE_SIDE,
    CHANGE_BACKGROUND_COLOR,
    CHANGE_BACKGROUND_IMAGES,
    CHANGE_BACKGROUND_IMAGES_TYPE,
    CHANGE_TAB_DESIGN,
    CHANGE_BACKGROUND_IMAGES_REF,
    CHANGE_LOADING_BACKGROUND,
    UPDATE_LIST_BACKGROUND_IMAGES,
    CHANGE_LINKED_VARIANT,
    CHANGE_SELECTED_LAYER,
    CHANGE_STAGE_DRAG,
    CHANGE_STATUS_PUBLISH,
    CREATE_STAGE_REF,
    DUPLICATE_LAYER,
    INIT_APPLIED_VARIANTS,
    INIT_PRODUCT_DATA,
    INIT_LIBRARIES,
    MOVE_LAYERS,
    REDO_HISTORY,
    REMOVE_SELECTED_LAYER,
    RERENDER_STATE,
    SET_CAMPAIGN_DETAIL,
    UNDO_HISTORY,
    UPDATE_GALLERY_IMAGE,
    UPDATE_LAYER_ATTRIBUTE,
    UPDATE_PICKER_VARIANTS,
    UPDATE_PREVIEW_IMAGES,
    UPDATE_SCREEN_DISPLAY,
    UPDATE_SELECTED_ATTRIBUTE,
    UPDATE_SIZE_EDITOR_WRAPPER,
    UPDATE_VARIANT_RETAIL_PRICE,
    SET_RUNNING_IMAGE_COMPRESS,
    SET_IMAGE_COMPRESS_PROGRESS,
    SET_IS_ADMIN,
    COPY_LAYER,
    PASTE_LAYER,
    UPDATE_APPLY_ALL_PLACEMENTS,
    UPDATE_IMAGE_LAYER_LOADING,
    SET_MULTI_SELECTION_LAYERS,
    UPDATE_FONTS,
    UPDATE_PREVIEW_IMAGES_3D,
    OPEN_CROP_MODE,
    UPDATE_LAYER_IMAGE,
    SET_SELECTED_TEMPLATE,
    UPDATE_REMOVE_BACKGROUND_MODE,
    GET_CLIENT_RECT,
    SAVE_CROP_LOCAL,
    ACTION_SAVE_TEMPLATE,
    SET_DISABLED_MULTI_SELECTION,
    TRIGGER_LOAD_TEMPLATE,
    OPEN_USER_GUIDE_POPUP,
    UPDATE_SELECTED_PLACEMENTS,
    SET_MAPPING_PRODUCT,
    CAPTURE_BACKGROUND_DESIGN
} from './constants'
import {
    handleAddImageLayer,
    handleAddTextLayer,
    handleChangeActiveSide,
    handleChangeBgColor,
    handleChangeBgImage,
    handleChangeBgImageType,
    handleChangeBgImageRef,
    handleSetLoadingBackground,
    handleUpdateListBackgroundImages,
    handleChangeLinkedVariant,
    handleChangeSelectedAttribute,
    handleCreateStageRef,
    handleDuplicateLayer,
    handleInitAppliedVariants,
    handleMoveLayers,
    handleRedo,
    handleRemoveLayer,
    handleSaveCacheCapture,
    handleUndo,
    handleUpdateLayerAttribute,
    handleUpdatePickerVariants,
    handleUpdateProductDetail,
    handleChangeApplyAllPlacements,
    handleSetTabDesign,
    handleSetSelectedTemplate,
    getTypeProductCreated,
    handleAddImageFromLibrary,
    handleUpdateSelectedPlacements,
    actionSetMappingProduct
} from './helper'

// import {getRatioDefault, hideToolbar} from './helper'

/**
 * @param {State} state
 * @param {*} action
 * @returns
 */
const reducer = (state, action) => {
    switch (action.type) {
        case INIT_LIBRARIES:
            return {
                ...state,
                libraries: action.payload
            }
        case INIT_PRODUCT_DATA:
            const {_id, title, attributes, description, slug, mockups, mockup_type} = action.payload
            const has3DPreview = mockups[0]?.meta?.version === 'v3' && !!mockups[0].preview_v3
            const useClientMockup = mockups[0]?.meta?.use_client_mockup
            return {
                ...state,
                product: action.payload,
                productDetail: {
                    ...state.productDetail,
                    _id,
                    title,
                    slug,
                    attributes,
                    description,
                    mockup_type,
                },
                productCreatedType: getTypeProductCreated(action.payload),
                has3DPreview,
                useClientMockup,
            }
        case UNDO_HISTORY:
            return handleUndo(state)
        case REDO_HISTORY:
            return handleRedo(state)
        case CHANGE_STATUS_PUBLISH:
            return {
                ...state,
                isPublish: action.payload,
            }
        case UPDATE_SIZE_EDITOR_WRAPPER:
            return {
                ...state,
                editorWrapper: {...state.editorWrapper, ...action.payload},
            }
        case UPDATE_SCREEN_DISPLAY:
            if (action.payload === 'design') {
                return {
                    ...state,
                    display: action.payload,
                    selectedLayer: null,
                    runningImageCompress: false,
                    imageCompressProgress: 0,
                }
            }
            return {
                ...state,
                display: action.payload,
            }
        case INIT_APPLIED_VARIANTS:
            return handleInitAppliedVariants(state)
        case UPDATE_VARIANT_RETAIL_PRICE:
            return {
                ...state,
                pickerVariants: action.payload,
            }
        case CREATE_STAGE_REF:
            return handleCreateStageRef(state, action.payload)
        case CHANGE_ACTIVE_SIDE:
            return handleChangeActiveSide(state, action.payload)
        case CHANGE_STAGE_DRAG:
            const isDrag = action.payload
            if (isDrag === state.stageDrag) return state
            return {
                ...state,
                stageDrag: isDrag ?? !state.stageDrag,
                selectedLayer: null,
            }
        case ADD_TEXT_LAYER:
            return handleAddTextLayer(state)
        case ADD_IMAGE_FROM_LIBRARY:
            return handleAddImageFromLibrary(state)
        case CHANGE_SELECTED_LAYER:
            if (!!action.payload)
                return {
                    ...state,
                    selectedLayer: action.payload,
                    multiSelectionLayers: [],
                    originalTransformerRect: null,
                }
            return {
                ...state,
                multiSelectionLayers: [],
                selectedLayer: action.payload,
            }
        case UPDATE_LAYER_ATTRIBUTE:
            const {layer, updateHistory} = action.payload
            return handleUpdateLayerAttribute(state, layer, updateHistory)
        case ADD_IMAGE_LAYER:
            return handleAddImageLayer(state, action.payload)
        case REMOVE_SELECTED_LAYER:
            return handleRemoveLayer(state, action.payload)
        case DUPLICATE_LAYER:
            return handleDuplicateLayer(state, action.payload)
        case MOVE_LAYERS:
            return handleMoveLayers(state, action.payload)
        case UPDATE_PICKER_VARIANTS:
            return handleUpdatePickerVariants(state, action.payload)
        case UPDATE_SELECTED_ATTRIBUTE:
            return handleChangeSelectedAttribute(state, action.payload)
        case CHANGE_LINKED_VARIANT:
            return handleChangeLinkedVariant(state, action.payload)
        case UPDATE_PREVIEW_IMAGES:
            return {
                ...state,
                previewImages: action.payload,
                // loadedPreviewImages: action.payload,
                reloadPreview: false,
            }
        case UPDATE_PREVIEW_IMAGES_3D:
            return {
                ...state,
                previewImages3D: action.payload,
            }
        case CHANGE_BACKGROUND_COLOR:
            return handleChangeBgColor(state, action.payload)
        case CHANGE_BACKGROUND_IMAGES:
            return handleChangeBgImage(state, action.payload)
        case CHANGE_BACKGROUND_IMAGES_TYPE:
            return handleChangeBgImageType(state, action.payload)
        case CHANGE_TAB_DESIGN:
            return handleSetTabDesign(state, action.payload)
        case CHANGE_BACKGROUND_IMAGES_REF:
            return handleChangeBgImageRef(state, action.payload)
        case CHANGE_LOADING_BACKGROUND:
            return handleSetLoadingBackground(state, action.payload)
        case UPDATE_LIST_BACKGROUND_IMAGES:
            return handleUpdateListBackgroundImages(state, action.payload)
        case RERENDER_STATE:
            return {...state}
        case SAVE_CACHE_CAPTURE:
            return handleSaveCacheCapture(state, action.payload)
        case UPDATE_GALLERY_IMAGE:
            return {
                ...state,
                galleryImage: action.payload,
            }
        case SET_CAMPAIGN_DETAIL:
            return handleUpdateProductDetail(state, action.payload)
        case SET_RUNNING_IMAGE_COMPRESS:
            return {
                ...state,
                runningImageCompress: action.payload,
            }
        case SET_IMAGE_COMPRESS_PROGRESS:
            return {
                ...state,
                imageCompressProgress: action.payload,
            }
        case SET_IS_ADMIN:
            return {
                ...state,
                isAdmin: action.payload,
            }
        case COPY_LAYER:
            return {
                ...state,
                copyLayer: action.payload,
            }
        case PASTE_LAYER:
            if (!state.copyLayer) return state
            const payload = {
                currLayer: state.copyLayer,
                options: {scopeAll: false},
            }
            return handleDuplicateLayer(state, payload)
        case UPDATE_APPLY_ALL_PLACEMENTS:
            return handleChangeApplyAllPlacements(state, action.payload)
        case UPDATE_IMAGE_LAYER_LOADING:
            return {
                ...state,
                loadingImageLayer: action.payload,
            }
        case UPDATE_FONTS:
            return {
                ...state,
                fonts: action.payload,
            }
        case OPEN_CROP_MODE:
            return {
                ...state,
                cropMode: action.payload,
            }
        case UPDATE_LAYER_IMAGE:
            const {layerId, imageUrl} = action.payload
            // Find the layer in all stages and update its image
            const updatedStages = state.stages.map((stageGroup) => {
                return stageGroup.map((stage) => {
                    const updatedLayers = stage.layers.map((layer) => {
                        if (layer.id === layerId) {
                            // Update the layer's image
                            return {
                                ...layer,
                                src: imageUrl,
                            }
                        }
                        return layer
                    })
                    return {...stage, layers: updatedLayers}
                })
            })

            // Update the selected layer if it's the one being modified
            const updatedSelectedLayer =
                state.selectedLayer && state.selectedLayer.id === layerId
                    ? {...state.selectedLayer, src: imageUrl}
                    : state.selectedLayer

            return {
                ...state,
                stages: updatedStages,
                selectedLayer: updatedSelectedLayer,
                // Add to history for undo/redo
                history: [
                    ...state.history.slice(0, state.historyIndex + 1),
                    {
                        stages: updatedStages,
                        selectedLayer: updatedSelectedLayer,
                    },
                ],
                historyIndex: state.historyIndex + 1,
            }
        case SET_MULTI_SELECTION_LAYERS:
            return {
                ...state,
                ...action.payload,
                selectedLayer: null,
            }
        case SET_SELECTED_TEMPLATE:
            return handleSetSelectedTemplate(state, action.payload)
        case UPDATE_REMOVE_BACKGROUND_MODE:
            return {
                ...state,
                removeBackgroundMode: action.payload,
            }
        case ACTION_SAVE_TEMPLATE:
            return {
                ...state,
                modalSaveTemplate: action.payload,
            }
        case GET_CLIENT_RECT:
            return {
                ...state,
                clientRect: action.payload,
            }
        case SAVE_CROP_LOCAL:
            return {
                ...state,
                cropLocal: action.payload,
            }
        case SET_DISABLED_MULTI_SELECTION:
            return {
                ...state,
                disabledMultiSelection: action.payload,
            }
        case TRIGGER_LOAD_TEMPLATE:
            return {
                ...state,
                triggerLoadTemplate: !state.triggerLoadTemplate,
            }
        case OPEN_USER_GUIDE_POPUP:
            return {
                ...state,
                openUserGuidePopup: true,
            }
        case UPDATE_SELECTED_PLACEMENTS:
            return handleUpdateSelectedPlacements(state, action.payload)
        case SET_MAPPING_PRODUCT:
            return {
                ...state,
                mappingProduct: action.payload,
            }
        case CAPTURE_BACKGROUND_DESIGN:
            const {newDesignCapture, hasCombined} = action.payload
            return {
                ...state,
                runningImageCombine: !hasCombined,
                designsCaptures: newDesignCapture,
            }
        default:
            return state
    }
}

export default reducer
